import { reportMykissClientError } from '../../helpers/errorHandling/client';
import { pathToUrl } from '../../helpers/urls';
import { ICoordinates } from '../../interfaces/geo';

export interface Species {
  aggregate_name: null | string;
  id: number;
  bag_limit: number;
  fish_id: number;
  fishbrain_ids: string[];
  shape: string;
  synonyms: string[];
  species: string;
  prohibited: number;
  specie_shape_id: number;
  location_name: string;
  location_rank: number;
  location_id: number;
  effective_at: string;
  freshwater: number;
  saltwater: number;
  location_freshwater: number;
  location_saltwater: number;
  location_regulation_notes: string;
  location_prohibited_message: string;
  prohibitions: unknown[];
  restrictions: unknown[];
  requirements: unknown[];
}

type Result = { success: true; results: Species[] } | { success: false; message: string };

export async function getAllSpeciesAtLocation(
  { latitude, longitude }: ICoordinates,
  signal?: AbortSignal,
): Promise<Species[]> {
  try {
    const response = await fetch(pathToUrl('/api/_fishrules/get-all-species-at-location'), {
      body: JSON.stringify({ latitude, longitude }),
      method: 'POST',
      signal,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
    const json: Result = await response.json();

    if (!json.success) {
      throw new Error(json.message);
    }

    return json.results;
  } catch (error) {
    reportMykissClientError(error);
    return [];
  }
}
